import Vue from 'vue';
import Component from 'vue-class-component';
import ABaseComponent from 'Components/Base/ABaseComponent';
import { Prop } from "vue-property-decorator";

@Component({})
export default class RegisterLoginComponent extends ABaseComponent {
    @Prop()
    customerNumber: string; 

    created() {
        this.loading = false;

        this.pushEvent();
    }

    pushEvent() {
        let win = window as any; 

        //If no customerNumber, just forget it
        if (!this.customerNumber) 
            return;

        const dataString = win.localStorage.getItem('lastUserLogin') as string;
        const lastLoginData = dataString == null ? 0 : +dataString;        
        const dateNow = new Date(Date.now());
        const lastDate = new Date(lastLoginData); //0 defaults to 01-01-1970

        //Remove Time part for better compare
        dateNow.setHours(0, 0, 0, 0);
        lastDate.setHours(0, 0, 0, 0);

        //Determine if it's time to push new event. Allow only one event per day. 
        if (dateNow > lastDate) {

            //Push event
            win.dataLayer = win.dataLayer || [];
            win.dataLayer.push({
                'event': 'login',
                'userId': this.customerNumber,
            });

            //Set last login
            win.localStorage.setItem('lastUserLogin', Date.now());
        }
    }
}
Vue.component('register-login', RegisterLoginComponent);